import {
  Box,
  TextField,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import React, { useState } from "react";
import { calculateAge } from "../../../../utils";
import { useTranslate } from "react-admin";
const useStyles = makeStyles((theme) => ({
  container: {
    margin: "0 20px 20px 0px",
    boxShadow: " 0px 2px 5px rgba(0, 0, 0, 0.15)",
    borderRadius: 12,
    backgroundColor: theme.lightGray,
  },
  fullNameLayout: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  birthDayMargin: { margin: "10px 0 20px 5px " },
  containerButton: {
    display: "flex",
    justifyContent: "center",
  },
  buttonCancle: {
    height: 50,
    borderRadius: 0,
    borderBottomLeftRadius: 12,
    width: "100%",
    backgroundColor: theme.darkGray2,
    "&:hover": {
      backgroundColor: theme.darkGray2,
    },
  },
  buttonSave: {
    height: 50,
    borderRadius: 0,
    borderBottomRightRadius: 12,
    width: "100%",
    backgroundColor: theme.blue,
    "&:hover": {
      backgroundColor: theme.blue,
    },
  },
  textStyle: {
    fontWeight: "normal",
    fontSize: "16px",
    alignItems: "center",
    textAlign: "center",
    lineHeight: 2,
    color: theme.darkGray,
  },
  textButtonStyle: {
    fontWeight: 600,
    fontSize: 20,
    color: theme.pureWhite,
  },
  fullnameTitle: {
    marginBottom: 10,
  },
}));

function EditPersonalInformation({ userProfileData, onSave, onCancel }) {
  const [engName, setEngName] = useState({
    firstname: userProfileData.firstName,
    lastname: userProfileData.lastName,
    nickname: userProfileData.nickName,
  });

  const [birthdate, setBirthdate] = useState(userProfileData.birthday);
  const classes = useStyles();
  const translate = useTranslate();
  const handleNameChange = (value, fieldName) => {
    const fields = fieldName.split(".");

    if (fields.length === 1) {
      return setBirthdate(value);
    }
    //Stupid approch
    if (fields[0] === "engName") {
      if (fields[1] === "firstname") {
        return setEngName({ ...engName, firstname: value });
      }
      if (fields[1] === "lastname") {
        return setEngName({ ...engName, lastname: value });
      }

      if (fields[1] === "nickname") {
        return setEngName({ ...engName, nickname: value });
      }
      return alert("Error" + fields[1]);
    }

    return alert("Not match anything" + fieldName);
  };

  return (
    <Box className={classes.container}>
      <Box margin="20px">
        <Typography className={classes.fullnameTitle}>
          {translate("ra.text.ci.generalInformation.fullName")}
        </Typography>
        <Box className={classes.fullNameLayout}>
          <Box display="flex">
            <TextField
              required
              variant="outlined"
              value={engName?.firstname}
              onChange={(e) =>
                handleNameChange(e.target.value, "engName.firstname")
              }
            />
            <Box width="20px" />
            <TextField
              required
              variant="outlined"
              value={engName?.lastname}
              onChange={(e) =>
                handleNameChange(e.target.value, "engName.lastname")
              }
            />
            <Box width="20px" />
            <TextField
              required
              variant="outlined"
              value={engName?.nickname}
              onChange={(e) =>
                handleNameChange(e.target.value, "engName.nickname")
              }
            />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between">
          <Box display="flex">
            <Typography className={classes.birthDayMargin}>
              {translate("ra.text.ci.generalInformation.birthday")}
            </Typography>
            <Box width="20px" />
            <TextField
              variant="outlined"
              type="date"
              value={changeDateFormat(new Date(birthdate))}
              onChange={(e) => {
                handleNameChange(e.target.value, "birthdate");
              }}
            />
          </Box>
        </Box>
        <Box display="flex">
          <Box width="10px" />
          <Typography className={classes.textStyle}>
            {translate("ra.text.ci.generalInformation.age")}
          </Typography>
          <Box width="128px" />
          <Typography className={classes.textStyle}>
            {calculateAge(new Date(birthdate))}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.containerButton} onClick={onCancel}>
        <Button className={classes.buttonCancle}>
          <Typography className={classes.textButtonStyle}>
            {translate("ra.action.cancel")}
          </Typography>
        </Button>
        <Button
          className={classes.buttonSave}
          onClick={() =>
            onSave({
              ...engName,
              birthdate: birthdate,
            })
          }
        >
          <Typography className={classes.textButtonStyle}>
            {translate("ra.action.save")}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}

const changeDateFormat = (date) => {
  const month =
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
  const dateOfTime = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
  let formatted_date = date.getFullYear() + "-" + month + "-" + dateOfTime;

  return formatted_date;
};

export default EditPersonalInformation;
